export { SpaceNvbPublicSpacePage as default } from "@nvb/ui";
